import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

export const SubtaskIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '20';
			default:
				return '20';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '16';
			default:
				return '16';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg
				width={getWidth(size)}
				height={getHeight(size)}
				fill={color}
				viewBox="0 0 20 16"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule={color}>
					<g id="Icon-Archieve" transform="translate(-223.000000, -39.000000)" fill={color}>
						<path
							d="M225,53 L241,53 L241,41 L225,41 L225,53 Z M225,55 C223.897,55 223,54.102 223,53 L223,41 C223,39.897 223.897,39 225,39 L241,39 C242.103,39 243,39.897 243,41 L243,53 C243,54.102 242.103,55 241,55 L225,55 Z M231.375,46 L231.375,44 L238.541,44 L238.541,46 L231.375,46 Z M231.375,50 L231.375,48 L238.541,48 L238.541,50 L231.375,50 Z M229.6253,44.9998 C229.6253,45.6898 229.0653,46.2498 228.3753,46.2498 C227.6853,46.2498 227.1253,45.6898 227.1253,44.9998 C227.1253,44.3098 227.6853,43.7498 228.3753,43.7498 C229.0653,43.7498 229.6253,44.3098 229.6253,44.9998 Z M229.6253,48.9998 C229.6253,49.6898 229.0653,50.2498 228.3753,50.2498 C227.6853,50.2498 227.1253,49.6898 227.1253,48.9998 C227.1253,48.3098 227.6853,47.7498 228.3753,47.7498 C229.0653,47.7498 229.6253,48.3098 229.6253,48.9998 Z"
							id="ico-subtask"
						></path>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

SubtaskIcon.SIZE = SIZE;
SubtaskIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

SubtaskIcon.defaultProps = {
	color: '#ADAFB8',
};

export const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
